// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Button, Col, Popconfirm, Row } from "antd";
import { DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons/lib";
import { useTranslation } from "react-i18next";
import { SurveyAnswerBlockProps } from "../../../types/SurveyTypes";
import FormField from "../../../components/FormField";

export const AnswerBlock: React.FunctionComponent<SurveyAnswerBlockProps> = (
  props: SurveyAnswerBlockProps
) => {
  const { t } = useTranslation();

  const {
    answer,
    indexAnswer,
    indexQuestion,
    editMode,
    handleDeleteAnswer,
    handleUpdateAnswer
  } = props;

  return (
    <div
      id={`nbo-question${indexQuestion}-answerChoice${indexAnswer}`}
      className="d-flex flex-column align-items-stretch nbo-block"
    >
      <Row>
        <Col xs={24} sm={18}>
          <FormField
            labelName={t("survey.add_question.answer.title", {
              indexAnswer: indexAnswer + 1
            })}
            defaultValue={answer.label}
            required={true}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            onChange={value => {
              answer.label = value.target.value;
              handleUpdateAnswer(answer, indexAnswer);
            }}
          />
        </Col>
        {editMode && (
          <Col xs={24} sm={6}>
            <div>
              <Popconfirm
                title={t("survey.add_question.cancel_confirmation")}
                okText={t("global.yes")}
                cancelText={t("global.no")}
                onConfirm={() => handleDeleteAnswer(indexAnswer)}
                placement="top"
                icon={<QuestionCircleOutlined />}
              >
                <Button htmlType="reset" className="btn-danger ml-2">
                  <DeleteOutlined /> {t("survey.add_question.delete")}
                </Button>
              </Popconfirm>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

AnswerBlock.defaultProps = {
  editMode: true
};
